import { BaseObserver } from "@zebrabi/observers";

class ActionObserver implements BaseObserver<string> {
    public static readonly CLASS_NAME = "ActionObserver";
    getClassName() {
        return ActionObserver.CLASS_NAME;
    }

    update: (message: string, eventName?: string) => void;
}

export default ActionObserver;
